import { useQuery } from '@tanstack/react-query';
import { useParams, Navigate } from 'react-router-dom';

import { api } from '@/lib/api';
import { ProjectSettings } from '@/components/project-settings';

export default function ProjectPage(): import('react/jsx-runtime').JSX.Element {
  const { id: projectId = '' } = useParams<{ id: string }>();

  const { data, isLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => api.getProject(projectId),
    enabled: projectId.length > 0,
    staleTime: 30 * 1000,
  });

  if (isLoading) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-muted border-t-foreground" />
      </div>
    );
  }

  if (data?.project == null) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <div className="mx-auto max-w-6xl px-4 py-6">
      <ProjectSettings project={data.project} />
    </div>
  );
}
